import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["progress", "chart", "status", "bar"];
  static values = {
    url: String,
    waveLabel: String,
    failedLabel: String,
    cacheDisabledLabel: String,
  };

  connect() {
    this.progressTarget.classList.remove("hidden");
    this.chartTarget.classList.add("hidden");
    this.chartTarget.innerHTML = "";
    this.barTarget.style.width = "0%";
    this.poll();
  }

  disconnect() {
    this.polling = false;
    if (this.timer) clearTimeout(this.timer);
  }

  async poll() {
    this.polling = true;

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();
      const pct = data.waves_total > 0 ? (data.waves_completed / data.waves_total) * 100 : 0;

      this.barTarget.style.width = `${pct}%`;

      if (data.waves_total > 0) {
        this.statusTarget.textContent = `${this.waveLabelValue} ${data.waves_completed}/${data.waves_total}...`;
      }

      if (data.failed) {
        if (data.failed_reason === "cache_disabled") {
          this.statusTarget.textContent = this.cacheDisabledLabelValue || "Cache disabled";
        } else {
          this.statusTarget.textContent = this.failedLabelValue || "Solver failed";
        }
        this.polling = false;
      } else if (data.done && data.html) {
        this.barTarget.style.width = "100%";
        setTimeout(() => {
          this.chartTarget.innerHTML = data.html;
          this.chartTarget.classList.remove("hidden");
          this.progressTarget.classList.add("hidden");
        }, 200);
        this.polling = false;
      } else if (this.polling) {
        this.timer = setTimeout(() => this.poll(), 3000);
      }
    } catch (error) {
      this.statusTarget.textContent = `Retrying (${error.message})...`;
      if (this.polling) {
        this.timer = setTimeout(() => this.poll(), 5000);
      }
    }
  }
}
